import React, { FC, useId } from 'react'

import { Colors } from 'common-constants/colors'

export const VerifiedSvg: FC<{
  uid?: string | number
  size?: number | string
  startColor?: string
  stopColor?: string
}> = ({
  uid,
  size = 18,
  startColor = Colors.lightBlue,
  stopColor = Colors.link,
}) => {
  const idFallback = useId()
  const id = `${uid ?? idFallback}1`
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.7143 1.11396C5.84667 1.31546 6.1091 1.38575 6.32454 1.27742L6.84086 1.01764C7.14615 0.864211 7.50871 1.07351 7.52835 1.4146L7.56159 1.99168C7.57552 2.23239 7.76758 2.42453 8.00829 2.43837L8.58546 2.47161C8.92647 2.49134 9.13577 2.8539 8.98234 3.1591L8.72256 3.67542C8.61422 3.89093 8.68459 4.15336 8.8861 4.28574L9.36919 4.60304C9.65474 4.79062 9.65474 5.2093 9.36919 5.39688L8.8861 5.71418C8.68459 5.84655 8.61422 6.10898 8.72256 6.32442L8.98234 6.84082C9.13577 7.14602 8.92647 7.50858 8.58546 7.52822L8.00829 7.56155C7.76758 7.57539 7.57552 7.76753 7.56159 8.00824L7.52835 8.58532C7.50871 8.92641 7.14615 9.13571 6.84086 8.9822L6.32454 8.7225C6.1091 8.61417 5.84667 8.68446 5.7143 8.88596L5.39691 9.36913C5.20933 9.65468 4.79073 9.65468 4.60315 9.36913L4.28576 8.88596C4.15339 8.68446 3.89096 8.61417 3.67552 8.7225L3.15912 8.9822C2.85391 9.13571 2.49135 8.92641 2.47171 8.58532L2.43847 8.00824C2.42454 7.76753 2.23248 7.57539 1.99169 7.56155L1.4146 7.52822C1.07359 7.50858 0.864212 7.14602 1.01773 6.84082L1.2775 6.32442C1.38584 6.10898 1.31547 5.84655 1.11396 5.71418L0.630793 5.39688C0.345318 5.2093 0.345318 4.79062 0.630793 4.60304L1.11396 4.28574C1.31547 4.15336 1.38584 3.89093 1.2775 3.67542L1.01773 3.1591C0.864212 2.8539 1.07359 2.49134 1.4146 2.47161L1.99169 2.43837C2.23248 2.42453 2.42454 2.23239 2.43847 1.99168L2.47171 1.4146C2.49135 1.07351 2.85391 0.864211 3.15912 1.01764L3.67552 1.27742C3.89096 1.38575 4.15339 1.31546 4.28576 1.11396L4.60315 0.630793C4.79073 0.345237 5.20933 0.345237 5.39691 0.630793L5.7143 1.11396Z"
        fill={`url(#${id})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.30554 3.86296C7.49751 4.05329 7.49883 4.3632 7.3085 4.55517L5.47481 6.4046C5.07471 6.80814 4.4236 6.81209 4.01864 6.41344L3.07761 5.48708C2.88497 5.29744 2.88253 4.98753 3.07217 4.79489C3.26182 4.60224 3.57172 4.5998 3.76437 4.78945L4.7054 5.7158C4.72605 5.73612 4.75924 5.73592 4.77964 5.71535L6.61333 3.86592C6.80366 3.67395 7.11357 3.67262 7.30554 3.86296Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={id}
          x1="-1.98261"
          y1="-2.4316"
          x2="-1.98261"
          y2="11.5337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={startColor} />
          <stop offset="1" stopColor={stopColor} />
        </linearGradient>
      </defs>
    </svg>
  )
}
